// Offshore Outcasts — homepage cinematic engine.
// Loaded only on the index template (see layout/theme.liquid).
// Cursor tracking lives in layout/theme.liquid — it's global, this file owns homepage-only behavior.

(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Horizon 4.1+ introduces an optional desktop layout (>=990px) where
  // .page-wrapper — not the window — is the actual scrolling element, so
  // side drawers can push content over instead of overlaying it. window
  // itself stops scrolling entirely in that mode (html/body get
  // height:100dvh + overflow:hidden). Every scroll listener / scrollY read
  // / scrollTo call below has to target whichever element is really
  // scrolling, or the hero never advances and anchor links jump nowhere.
  function getScroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && getComputedStyle(pw).overflowY === 'auto') return pw;
    return window;
  }
  function getScrollTop() {
    var s = getScroller();
    return s === window ? window.scrollY : s.scrollTop;
  }
  function scrollerScrollTo(opts) {
    getScroller().scrollTo(opts);
  }

  var INTRO_SESSION_KEY = 'oo-intro-shown';
  var alreadyShownIntro = false;
  try {
    alreadyShownIntro = window.sessionStorage && sessionStorage.getItem(INTRO_SESSION_KEY) === '1';
  } catch (e) {
    /* sessionStorage unavailable (private mode, etc.) — fall back to showing intro every time */
  }
  var skipIntroEntirely = prefersReducedMotion || alreadyShownIntro;

  // ── Intro screen with wave loader ──
  (function () {
    var intro = document.getElementById('intro');
    if (!intro) return;

    if (skipIntroEntirely) {
      intro.style.display = 'none';
      document.body.classList.remove('intro-active');
      document.body.classList.add('intro-done');
      var v0 = document.getElementById('vid0');
      if (v0 && !prefersReducedMotion) v0.play().catch(function () {});
      return;
    }

    document.body.classList.add('intro-active');
    var num = document.getElementById('intro-num');
    var fill = document.getElementById('intro-fill');
    var barContainer = document.getElementById('intro-progress-bar');
    var waveCanvas = document.getElementById('intro-wave-canvas');
    var boatEl = document.getElementById('intro-boat');

    var pct = 0;
    var wt = 0;
    var waveRaf = null;
    var dismissed = false;

    function resizeCanvas() {
      if (!waveCanvas || !barContainer) return;
      waveCanvas.width = barContainer.offsetWidth;
      waveCanvas.height = barContainer.offsetHeight;
    }
    resizeCanvas();

    if (boatEl && barContainer) {
      boatEl.style.left = '0px';
      boatEl.style.opacity = '1';
    }

    function animateWave() {
      if (!waveCanvas || !barContainer) return;
      var ctx = waveCanvas.getContext('2d');
      var W = waveCanvas.width;
      var H = waveCanvas.height;
      ctx.clearRect(0, 0, W, H);

      ctx.beginPath();
      for (var x = 0; x <= W; x += 2) {
        var y = H * 0.4 + Math.sin(x * 0.045 + wt) * 3 + Math.cos(x * 0.028 + wt * 0.8) * 2;
        x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      }
      ctx.lineTo(W, H);
      ctx.lineTo(0, H);
      ctx.closePath();
      var grad = ctx.createLinearGradient(0, 0, 0, H);
      grad.addColorStop(0, 'rgba(126,207,255,0.3)');
      grad.addColorStop(1, 'rgba(13,34,53,0.95)');
      ctx.fillStyle = grad;
      ctx.fill();

      ctx.beginPath();
      for (var x2 = 0; x2 <= W; x2 += 2) {
        var y2 = H * 0.4 + Math.sin(x2 * 0.045 + wt) * 3 + Math.cos(x2 * 0.028 + wt * 0.8) * 2;
        x2 === 0 ? ctx.moveTo(x2, y2) : ctx.lineTo(x2, y2);
      }
      ctx.strokeStyle = 'rgba(126,207,255,0.6)';
      ctx.lineWidth = 1;
      ctx.stroke();

      if (boatEl && barContainer) {
        var barW = barContainer.offsetWidth;
        var boatX = (pct / 100) * barW;
        var bobY = Math.sin(wt * 1.2) * 2;
        var rot = Math.sin(wt * 0.9) * 3;
        boatEl.style.left = boatX + 'px';
        boatEl.style.transform = 'translate(-50%, calc(-50% + ' + bobY + 'px)) rotate(' + rot + 'deg)';
      }

      wt += 0.04;
      waveRaf = requestAnimationFrame(animateWave);
    }
    animateWave();

    // Real, short — this is a brand flourish, not a gate on real assets.
    var duration = 1100;
    var interval = 30;
    var steps = duration / interval;
    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    var step = 0;
    var timer = setInterval(function () {
      step++;
      var t = step / steps;
      pct = Math.min(100, Math.round(easeOut(t) * 100));
      if (num) num.textContent = pct;
      if (fill) fill.style.width = pct + '%';
      if (pct >= 100) {
        clearInterval(timer);
        setTimeout(dismissIntro, 250);
      }
    }, interval);

    function dismissIntro() {
      if (dismissed) return;
      dismissed = true;
      clearInterval(timer);
      cancelAnimationFrame(waveRaf);
      try {
        sessionStorage.setItem(INTRO_SESSION_KEY, '1');
      } catch (e) {}
      if (intro) {
        intro.classList.add('exiting');
        function finishDismiss() {
          intro.style.display = 'none';
          intro.style.opacity = '0';
          intro.style.pointerEvents = 'none';
          document.body.classList.remove('intro-active');
          document.body.classList.add('intro-done');
          var v = document.getElementById('vid0');
          if (v) v.play().catch(function () {});
        }
        intro.addEventListener('animationend', finishDismiss, { once: true });
        setTimeout(finishDismiss, 600);
      }
    }

    intro.addEventListener('click', dismissIntro);
    window.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') dismissIntro();
      },
      { once: true }
    );
  })();

  // ── Canvas cinematic hero (vignette overlay only) ──
  var canvas = document.getElementById('hero-canvas');
  if (!canvas) return; // Defensive — this file should only ever run on the homepage.
  var ctx = canvas.getContext('2d');

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', function () {
    resize();
    draw();
  });

  function draw() {
    var cw = canvas.width,
      ch = canvas.height;
    ctx.clearRect(0, 0, cw, ch);

    ctx.fillStyle = 'rgba(4,8,15,0.45)';
    ctx.fillRect(0, 0, cw, ch);

    var vigGrad = ctx.createRadialGradient(cw / 2, ch / 2, ch * 0.25, cw / 2, ch / 2, ch * 0.85);
    vigGrad.addColorStop(0, 'transparent');
    vigGrad.addColorStop(1, 'rgba(2,6,14,0.7)');
    ctx.fillStyle = vigGrad;
    ctx.fillRect(0, 0, cw, ch);

    var btmGrad = ctx.createLinearGradient(0, ch * 0.75, 0, ch);
    btmGrad.addColorStop(0, 'transparent');
    btmGrad.addColorStop(1, 'rgba(4,8,15,0.95)');
    ctx.fillStyle = btmGrad;
    ctx.fillRect(0, ch * 0.7, cw, ch * 0.3);
  }
  draw();

  // ── Video switching — chapters after the first load on demand, not all upfront ──
  var videos = [
    document.getElementById('vid0'),
    document.getElementById('vid1'),
    document.getElementById('vid2'),
    document.getElementById('vid3'),
  ];
  var currentVid = 0;

  function ensureLoaded(v) {
    if (v && v.preload !== 'auto') {
      v.preload = 'auto';
      v.load();
    }
  }

  // play()/pause() wrappers that track each video's own in-flight play()
  // promise. Calling pause() on a video whose play() hasn't resolved yet
  // throws an "interrupted by a call to pause()" rejection and forces the
  // decoder to abort and restart — real, measurable main-thread/decoder
  // work. That's exactly what happens when a user scrolls back and forth
  // across a chapter boundary (most likely right as they reverse direction
  // after scrolling through the whole list): switchToVideo() fires for both
  // videos again before the first play() had time to settle. Chaining the
  // pause onto the real play() promise (never a timeout) means it always
  // lands after playback has actually started, so rapid reversal coalesces
  // instead of stacking up aborted decode work.
  function playVideo(v) {
    var p = v.play();
    v.__ooPlayPromise = p;
    if (p && typeof p.catch === 'function') p.catch(function () {});
    return p;
  }
  function pauseVideo(v) {
    var p = v.__ooPlayPromise;
    if (p && typeof p.then === 'function') {
      p.catch(function () {}).then(function () {
        v.pause();
      });
    } else {
      v.pause();
    }
  }

  function switchToVideo(idx) {
    if (idx === currentVid) return;
    var incoming = videos[idx];
    var outgoing = videos[currentVid];
    ensureLoaded(incoming);
    outgoing.classList.remove('active');
    incoming.classList.add('active');
    currentVid = idx;
    // Preload the next chapter ahead of time so the switch after this one is instant.
    if (videos[idx + 1]) ensureLoaded(videos[idx + 1]);
    if (incoming.paused) playVideo(incoming);
    pauseVideo(outgoing);
  }

  var engine = document.getElementById('scroll-engine');
  var progFill = document.getElementById('prog-fill');
  var scrollInd = document.getElementById('scroll-indicator');

  var CHAPTERS = 4;

  function setScene(p) {
    try {
      var si = Math.min(Math.floor(p * CHAPTERS), CHAPTERS - 1);
      switchToVideo(si);
      for (var i = 0; i < CHAPTERS; i++) {
        var sp = document.getElementById('sp' + i);
        var pc = document.getElementById('pc' + i);
        if (sp) sp.classList.toggle('active', i === si);
        if (pc) pc.classList.toggle('active', i === si);
      }
      if (progFill) progFill.style.width = p * 100 + '%';
      if (scrollInd) {
        if (p > 0.03) scrollInd.classList.add('hidden');
        else scrollInd.classList.remove('hidden');
      }
    } catch (err) {
      console.warn('setScene err', err);
    }
  }

  // Reduced motion: no scroll-linked scrubbing — collapse the track to a single
  // static viewport-height chapter and let native scroll carry straight through.
  if (prefersReducedMotion) {
    if (videos[0]) videos[0].pause();
    setScene(0);
    if (engine) engine.style.height = '100vh';
    if (scrollInd) scrollInd.classList.add('hidden');
    if (engine) {
      var reducedMotionScroller = window;
      var reducedMotionPageWrapper = document.querySelector('.page-wrapper');
      if (reducedMotionPageWrapper && getComputedStyle(reducedMotionPageWrapper).overflowY === 'auto') {
        reducedMotionScroller = reducedMotionPageWrapper;
      }
      function updateTransparentZoneReducedMotion() {
        var rect = engine.getBoundingClientRect();
        document.body.classList.toggle('in-hero-transparent-zone', rect.bottom > 0);
      }
      reducedMotionScroller.addEventListener('scroll', updateTransparentZoneReducedMotion, { passive: true });
      updateTransparentZoneReducedMotion();
    }
  } else {
    if (videos[0]) playVideo(videos[0]);
    if (videos[1]) ensureLoaded(videos[1]);

    // Chapter/video switching is driven purely by scroll position within the
    // (CHAPTERS * 100vh) tall #scroll-engine track — scrolling itself is
    // never intercepted, so a single fast scroll/swipe/Page Down skips
    // straight through to real page content, same as scrolling past any
    // other section.
    var ticking = false;
    function updateFromScroll() {
      ticking = false;
      if (!engine) return;
      var rect = engine.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      setScene(progress);
      // No draw() call here — the ambient loop below already redraws the
      // canvas on every animation frame whenever the hero is on/near screen,
      // which covers every scroll frame at a higher cadence than 'scroll'
      // events fire anyway. Calling it again here just doubled the canvas
      // work on every scroll frame for no visible benefit, which is exactly
      // the kind of main-thread cost that shows up as stutter on a fast
      // scroll — most noticeably right when the user reverses direction.
      // Horizon's native sticky header switches to a solid background almost
      // immediately on any scroll (same in the original theme too — confirmed
      // by testing it directly), which cuts the translucent look short while
      // still deep in the chapter sequence. Keep it translucent for as long
      // as the scroll-jacked hero's sticky video panel is still on screen
      // (i.e. the tall #scroll-engine track hasn't fully scrolled past),
      // and only let it go solid once real page content actually begins.
      document.body.classList.toggle('in-hero-transparent-zone', rect.bottom > 0);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateFromScroll);
    }
    // Listen on both window and .page-wrapper rather than picking one at
    // setup time: only whichever one is actually the scroller for the
    // current viewport width will ever fire, and updateFromScroll doesn't
    // care which one triggered it (it reads the hero's own bounding rect).
    // This also keeps it correct if the window is resized across the
    // 990px breakpoint without a full reload.
    window.addEventListener('scroll', onScroll, { passive: true });
    var pageWrapperEl = document.querySelector('.page-wrapper');
    if (pageWrapperEl) pageWrapperEl.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateFromScroll();
  }

  // ── Nav & page transition handler (internal links only) ──
  var pageTransition = document.getElementById('page-transition');
  function navigateTo(url) {
    if (!pageTransition || prefersReducedMotion) {
      window.location.href = url;
      return;
    }
    pageTransition.classList.add('active');
    setTimeout(function () {
      window.location.href = url;
    }, 350);
  }

  document.querySelectorAll('#homepage a, .scene-panel a').forEach(function (a) {
    var href = a.getAttribute('href');
    if (!href || href === '#') return;
    if (href.startsWith('#')) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector(href);
        if (!target) return;
        var top = target.getBoundingClientRect().top + getScrollTop() - 72;
        scrollerScrollTo({ top: top, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      });
      return;
    }
    if (href.startsWith('http') && !href.includes(window.location.hostname)) return;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      navigateTo(href);
    });
  });

  window.addEventListener('pageshow', function () {
    if (pageTransition) pageTransition.classList.remove('active');
  });

  // ── Ambient animation loop — only runs while the hero is actually on/near
  // screen. Previously this checked visibility with getBoundingClientRect()
  // on every single animation frame, forever, for the rest of the page's
  // life — including long after the user had scrolled past the hero and
  // deep into homepage content. A forced synchronous layout read 60x/sec
  // that never turns off competes with the browser for main-thread time on
  // every later scroll, which is exactly the kind of thing that makes a
  // scroll feel like it's "losing control," most noticeably when reversing
  // direction back toward the hero after scrolling through it. An
  // IntersectionObserver (same pattern already used below for the campaign
  // canvas) starts/stops the loop for real instead. ──
  var heroLoopActive = false;
  var heroLoopRunning = false;
  function animLoop() {
    if (!heroLoopActive) {
      heroLoopRunning = false;
      return;
    }
    if (document.visibilityState === 'visible') {
      try {
        draw();
      } catch (e) {}
    }
    requestAnimationFrame(animLoop);
  }
  if (engine) {
    var heroLoopObserver = new IntersectionObserver(function (entries) {
      heroLoopActive = entries[entries.length - 1].isIntersecting;
      if (heroLoopActive && !heroLoopRunning) {
        heroLoopRunning = true;
        animLoop();
      }
    });
    heroLoopObserver.observe(engine);
  }

  // ── Campaign canvas (mini animated scene) — paused off-screen via IntersectionObserver ──
  var cc = document.getElementById('campaign-canvas');
  if (cc && !prefersReducedMotion) {
    var ccx = cc.getContext('2d');
    var ccT = 0;
    var ccRunning = false;
    var ccWrap = document.getElementById('campaign-canvas-wrap');

    function resizeCC() {
      if (!ccWrap) return;
      cc.width = ccWrap.offsetWidth;
      cc.height = ccWrap.offsetHeight;
    }
    resizeCC();
    window.addEventListener('resize', resizeCC);

    var STARS_CC = Array.from({ length: 40 }, function () {
      return { x: Math.random(), y: Math.random(), r: Math.random() < 0.2 ? 1.4 : 0.8, o: 0.25 + Math.random() * 0.75 };
    });

    function drawCC() {
      if (!ccRunning) return;
      var w = cc.width,
        h = cc.height;
      if (!w || !h) {
        requestAnimationFrame(drawCC);
        return;
      }
      var skyGrad = ccx.createLinearGradient(0, 0, 0, h * 0.5);
      skyGrad.addColorStop(0, '#020810');
      skyGrad.addColorStop(1, '#081830');
      ccx.fillStyle = skyGrad;
      ccx.fillRect(0, 0, w, h * 0.52);

      var wGrad = ccx.createLinearGradient(0, h * 0.5, 0, h);
      wGrad.addColorStop(0, '#041020');
      wGrad.addColorStop(1, '#020c18');
      ccx.fillStyle = wGrad;
      ccx.fillRect(0, h * 0.5, w, h * 0.5);

      STARS_CC.forEach(function (s) {
        ccx.save();
        ccx.globalAlpha = s.o * 0.7;
        ccx.fillStyle = '#fff';
        ccx.beginPath();
        ccx.arc(s.x * w, s.y * h * 0.5, s.r * 0.8, 0, Math.PI * 2);
        ccx.fill();
        ccx.restore();
      });

      ccx.save();
      ccx.globalAlpha = 0.8;
      ccx.fillStyle = '#c8dff0';
      ccx.beginPath();
      ccx.arc(w * 0.8, h * 0.18, h * 0.09, 0, Math.PI * 2);
      ccx.fill();
      ccx.restore();

      var hgG = ccx.createLinearGradient(0, h * 0.46, 0, h * 0.56);
      hgG.addColorStop(0, 'transparent');
      hgG.addColorStop(0.5, 'rgba(26,74,112,0.6)');
      hgG.addColorStop(1, 'transparent');
      ccx.fillStyle = hgG;
      ccx.fillRect(0, h * 0.44, w, h * 0.14);

      for (var i = 0; i < 4; i++) {
        var wy = h * 0.52 + (i / 4) * h * 0.2;
        ccx.save();
        ccx.globalAlpha = 0.07;
        ccx.strokeStyle = '#7ecfff';
        ccx.lineWidth = 0.8;
        ccx.beginPath();
        for (var x2 = 0; x2 <= w; x2 += 3) {
          var y2 = wy + Math.sin(x2 * 0.02 + ccT * (1 + i * 0.2)) * 2;
          x2 === 0 ? ccx.moveTo(x2, y2) : ccx.lineTo(x2, y2);
        }
        ccx.stroke();
        ccx.restore();
      }

      var bx2 = w * 0.42,
        by2 = h * 0.52;
      ccx.save();
      ccx.globalAlpha = 0.9;
      ccx.translate(bx2, by2);
      ccx.scale(0.55, 0.55);
      ccx.fillStyle = '#0e0e0e';
      ccx.beginPath();
      ccx.moveTo(-90, 0);
      ccx.lineTo(90, 0);
      ccx.lineTo(70, 22);
      ccx.lineTo(-70, 22);
      ccx.closePath();
      ccx.fill();
      ccx.fillStyle = '#151515';
      ccx.fillRect(-80, -10, 160, 12);
      ccx.fillStyle = '#111';
      ccx.fillRect(-28, -46, 64, 38);
      ccx.fillStyle = 'rgba(126,207,255,0.4)';
      ccx.fillRect(-22, -40, 18, 12);
      ccx.fillRect(2, -40, 18, 12);
      ccx.strokeStyle = '#1e1e1e';
      ccx.lineWidth = 2;
      ccx.beginPath();
      ccx.moveTo(-10, -46);
      ccx.lineTo(-10, -110);
      ccx.stroke();
      ccx.lineWidth = 1.5;
      ccx.beginPath();
      ccx.moveTo(-10, -106);
      ccx.lineTo(40, -82);
      ccx.stroke();
      ccx.restore();

      var vigG = ccx.createRadialGradient(w / 2, h / 2, h * 0.2, w / 2, h / 2, h * 0.75);
      vigG.addColorStop(0, 'transparent');
      vigG.addColorStop(1, 'rgba(2,6,14,0.6)');
      ccx.fillStyle = vigG;
      ccx.fillRect(0, 0, w, h);

      ccx.save();
      ccx.globalAlpha = 0.04;
      ccx.fillStyle = '#7ecfff';
      ccx.font = 'bold ' + h * 0.5 + 'px serif';
      ccx.textAlign = 'center';
      ccx.textBaseline = 'middle';
      ccx.fillText('☠', w * 0.78, h * 0.62);
      ccx.restore();

      ccT += 0.2;
      requestAnimationFrame(drawCC);
    }

    var ccObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !ccRunning) {
            ccRunning = true;
            drawCC();
          } else if (!entry.isIntersecting) {
            ccRunning = false;
          }
        });
      },
      { threshold: 0.05 }
    );
    ccObserver.observe(cc);
  }

  // ── Intersection observer for section fade-ins ──
  if (!prefersReducedMotion) {
    try {
      var obsOpts = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
          }
        });
      }, obsOpts);

      document.querySelectorAll('.stat-cell,.pc,.feat,.testi-card').forEach(function (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(16px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        obs.observe(el);
      });

      document.querySelectorAll('.pgrid,.testi-grid,.features,.stats-row').forEach(function (grid) {
        Array.from(grid.children).forEach(function (child, i) {
          child.style.transitionDelay = i * 0.08 + 's';
        });
      });
    } catch (e) {}
  }
})();
